//
// Renote Companion — plugin id package.
//
// The @hcengineering scope is kept on purpose for consistency with the monorepo,
// even though this is a Renote-first, fork-authored plugin (see README).
//

import type { Ref } from '@hcengineering/core'
import type { Asset, IntlString, Metadata, Plugin } from '@hcengineering/platform'
import { plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui/src/types'
import type { Widget } from '@hcengineering/workbench'

/** @public */
export const companionId = 'companion' as Plugin

/**
 * Plugin ids for the Renote Companion.
 *
 * Mirrors the presence plugin: metadata for backend endpoints (see
 * presence.metadata.PresenceUrl), component ids for the workbench mount + host
 * surfaces, plus the sidebar Widget id/label/icon (love pattern).
 *
 * @public
 */
export const companionPlugin = plugin(companionId, {
  metadata: {
    // Base URL of the Companion backend (token mint, skills, usage log).
    // Wired in dev/prod/src/platform.ts via setMetadata (mirror presence.metadata.PresenceUrl).
    BackendUrl: '' as Metadata<string>,
    // Base URL of the LLM/Realtime proxy (server-side keys only).
    ProxyUrl: '' as Metadata<string>,
    // Contas liberadas a ver o companion (e-mail ou uuid, separados por
    // virgula). Vazio = todos; '*' = todos, explicitamente. O compose de
    // PRODUCAO exige o valor, para nunca publicar em silencio para todos.
    AllowedAccounts: '' as Metadata<string>
  },
  component: {
    // Mounted at workbench.extensions.WorkbenchExtensions — the Companion host that
    // portals to document.body, owns the cursor layer and the rootbar control.
    WorkbenchExtension: '' as AnyComponent,
    // The launcher/toggle rendered in the workbench rootbar.
    RootBarControl: '' as AnyComponent,
    // The transcript / act-log sidebar widget body.
    TranscriptWidget: '' as AnyComponent
  },
  ids: {
    // The workbench.class.Widget document for the transcript sidebar.
    TranscriptWidget: '' as Ref<Widget>
  },
  string: {
    Companion: '' as IntlString,
    Transcript: '' as IntlString
  },
  icon: {
    Companion: '' as Asset,
    // Pointing cursor mark. Registered by companion-assets (icons.svg#cursor).
    Cursor: '' as Asset
  }
})

export default companionPlugin
